import { Button } from 'components/Phantom/Button'
import styles from './QuizModal.module.scss'
import { Type } from 'components/Type'
import React from 'react'
import { Icon } from 'components/Phantom/Icon'
import { Logo } from 'components/Logo'
import cx from 'classnames'
import { Img } from 'components/basic/Img'
import { BottomLines, LeftLines } from './Lines'
import { QuizQuestionRenderProps } from './QuizQuestions'

const desktopImage =
	'https://res.cloudinary.com/eightsleep/image/upload/pod-4-hub-morning-bedroom_yekrfz.png'
const mobileImage =
	'https://res.cloudinary.com/eightsleep/image/upload/pod-4-hub-morning-bedroom-mobile_z1scfe'

const QuizSplashScreen: React.FC<QuizQuestionRenderProps> = ({
	handleNextQuestion,
	handleClose,
}) => {
	return (
		<div className={styles.modal_wrapper_content}>
			<div className={styles.left_image_wrapper}>
				<Img
					src={desktopImage}
					sources={[
						{
							mediaQuery: '(min-width: 1023px)',
							src: desktopImage,
							dprHeight: 2000,
							type: 'desktop',
						},
						{
							mediaQuery: '(max-width: 1023px)',
							src: mobileImage,
							dprHeight: 2000,
							type: 'mobile',
						},
					]}
					className={styles.left_image}
					alt="Pod 4 Hub Morning Bedroom"
					objectFit={'cover'}
					config={{
						desktop: {
							width: 1200,
							height: 2000,
						},
						mobile: {
							width: 850,
							height: 375,
						},
					}}
				/>
			</div>
			<div className={styles.quiz_question_container}>
				<div className={cx(styles.quiz_header, styles.quiz_header_splash_screen)}>
					<div className={styles.header_logo_wrapper}>
						<Logo />
					</div>
					<Button.Empty
						id="sleep-quiz-splash-close"
						type="button"
						aria-label="Close modal button"
						onClick={handleClose}
						className={styles.header_button}
					>
						<Icon name="CloseLight" />
					</Button.Empty>
				</div>

				<div className={styles.quiz_content_body_container}>
					<div className={styles.left_lines_wrapper}>
						<LeftLines />
					</div>
					<div className={styles.bottom_lines_wrapper}>
						<BottomLines />
					</div>
					<div className={styles.quiz_content_body}>
						<div className={styles.splash_screen_logo_wrapper}>
							<Logo className={styles.header_logo} />
						</div>
						<Type.Headline2 className={styles.headline}>
							Discover your <br /> perfect sleep set up
						</Type.Headline2>
						<Type.Body1 className={styles.headchapter}>
							Find the right sleep solution tailored to you needs.
						</Type.Body1>
						<Button.White
							id="sleep-quiz-splash-start"
							onClick={() => handleNextQuestion?.()}
							className={cx(styles.quiz_button, styles.splash_screen_button)}
						>
							Take quiz
						</Button.White>
					</div>
				</div>
			</div>
		</div>
	)
}

export default QuizSplashScreen
